module.exports = __webpack_public_path__ + "static/media/qrCodeSchool.15394e4f.svg";